import React, { useMemo } from 'react';
import { Box } from '@mui/joy';
import { KPI } from 'src/mtska-frontend-app-component';

const filterItems = (filters) => filters?.filterModel?.items ?? filters?.items ?? [];

const RentalManagerCarKPI = ({ filters }) =>
    useMemo(() => {
        const items = filterItems(filters);
        return (
            <Box className="mtska-chart-wrapper">
                <KPI
                    title="Vetture"
                    dataProviderName="statisticsviews/runningvehicles/count/cars/car"
                    filters={{ items: [...items] }}
                />
                <KPI
                    title="Customers"
                    dataProviderName="statisticsviews/runningcustomers/countdistinct/cars/car/legal_entity_id"
                    filters={{ items: [...items] }}
                />
                <KPI
                    title="Noleggiatori"
                    dataProviderName="statisticsviews/runningcustomers/countdistinct/cars/car/_related_renter_name"
                    filters={{ items: [...items] }}
                />
                <KPI
                    title="Commissioni"
                    dataProviderName="statisticsviews/runningcustomers/sumfinancial/cars/car/_related_contract_commission"
                    format="currency"
                    filters={{ items: [...items] }}
                />
            </Box>
        );
    }, [filters]);

export default RentalManagerCarKPI;
